import React, { Fragment, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { salaryAdvanceCreate } from "../../../services/payroll";
import { academyusergetdetail } from "../../../services/admin";

const EMP_TYPES = [{ value: "teacher", label: "Teacher" }, { value: "worker", label: "Worker" }];

export default function SalaryAdvance() {
  const navigate = useNavigate();
  const [empType, setEmpType]       = useState("");
  const [empId, setEmpId]           = useState("");
  const [amount, setAmount]         = useState("");
  const [reason, setReason]         = useState("");
  const [requestDate, setRequestDate] = useState(moment().format("YYYY-MM-DD"));
  const [recoveryMonths, setRecoveryMonths] = useState("1");
  const [errorMessage, setErrorMessage]     = useState("");
  const [loading, setLoading]       = useState(false);

  function handleSubmit() {
    setErrorMessage("");
    if (!empType)     { setErrorMessage("Please select employee type"); return; }
    if (!empId.trim()) { setErrorMessage("Please enter employee ID"); return; }
    if (!amount || parseFloat(amount) <= 0) { setErrorMessage("Please enter valid amount"); return; }

    setLoading(true);
    const temp = new FormData();
    temp.append("employee_type",   empType.value);
    temp.append("employee_id",     empId);
    temp.append("amount",          amount);
    temp.append("reason",          reason);
    temp.append("request_date",    requestDate);
    temp.append("recovery_months", recoveryMonths || 1);
    if (localStorage.getItem("Role") === "1") temp.append("academy_id", localStorage.getItem("AAcademy") || "");

    salaryAdvanceCreate(temp).then((res) => {
      setLoading(false);
      if (res?.status) { toast.success(res.message); navigate("/payroll/advance-list"); }
      else setErrorMessage(res?.message || "Something went wrong");
    });
  }

  const monthlyRecovery = amount && recoveryMonths > 0
    ? (parseFloat(amount) / parseFloat(recoveryMonths)).toFixed(2) : "0.00";

  return (
    <Fragment>
      <div className="page-header reported-header">
        <div>
          <h2 className="main-content-title tx-24 mg-b-5">Salary Advance</h2>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a>Payroll</a></li>
            <li className="breadcrumb-item active" aria-current="page">Salary Advance</li>
          </ol>
        </div>
      </div>

      <div className="content-body">
        <div className="container-fluid">
          <div className="card custom-card mg-b-20">
            <div className="card-body">
              <Row className="row-sm mx-0">
                <Col xxl={4} lg={4} md={6}>
                  <div className="mb-3">
                    <label className="form-label">Employee Type <span className="text-danger"> *</span></label>
                    <Select className="default-select" placeholder="Select Type" options={EMP_TYPES} value={empType} onChange={(e) => setEmpType(e)} isClearable />
                  </div>
                </Col>
                <Col xxl={4} lg={4} md={6}>
                  <div className="mb-3">
                    <label className="form-label">Employee ID <span className="text-danger"> *</span></label>
                    <input type="number" className="form-control" placeholder="Enter Employee DB ID" value={empId} onChange={(e) => setEmpId(e.target.value)} />
                  </div>
                </Col>
                <Col xxl={4} lg={4} md={6}>
                  <div className="mb-3">
                    <label className="form-label">Request Date <span className="text-danger"> *</span></label>
                    <input type="date" className="form-control" value={requestDate} onChange={(e) => setRequestDate(e.target.value)} />
                  </div>
                </Col>
                <Col xxl={4} lg={4} md={6}>
                  <div className="mb-3">
                    <label className="form-label">Advance Amount <span className="text-danger"> *</span></label>
                    <input type="number" className="form-control" placeholder="0.00" value={amount} onChange={(e) => setAmount(e.target.value)} />
                  </div>
                </Col>
                <Col xxl={4} lg={4} md={6}>
                  <div className="mb-3">
                    <label className="form-label">Recovery Months</label>
                    <input type="number" className="form-control" placeholder="1" min="1" value={recoveryMonths} onChange={(e) => setRecoveryMonths(e.target.value)} />
                  </div>
                </Col>
                <Col xxl={4} lg={4} md={6}>
                  <div className="mb-3">
                    <label className="form-label">Monthly Recovery</label>
                    <input type="text" className="form-control" readOnly value={monthlyRecovery} style={{ background: "#f8f9fa" }} />
                  </div>
                </Col>
                <Col xxl={8} lg={8} md={12}>
                  <div className="mb-3">
                    <label className="form-label">Reason</label>
                    <textarea className="form-control" rows={3} placeholder="Reason for advance..." value={reason} onChange={(e) => setReason(e.target.value)} />
                  </div>
                </Col>
                <Col xxl={12} lg={12} md={12}>
                  {errorMessage && <span className="text-danger d-block mb-2">{errorMessage}</span>}
                  <a onClick={handleSubmit} className={`btn btn-success me-2 ${loading ? "disabled" : ""}`}>
                    {loading ? "Submitting..." : "Submit Advance"}
                  </a>
                  <a onClick={() => navigate("/payroll/advance-list")} className="btn btn-secondary">View List</a>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
